module.exports = __webpack_public_path__ + "static/media/480.ad2a9dff.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-certificate/light/480.png
// module id = 1940
// module chunks = 2